// Hungarian (hu) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const hu = {
  'show all manuals': 'összes kézikönyv megjelenítése',
  eifuPortalIntro:
    'Böngéssze és töltse le a RAY orvostechnikai eszközszoftvereinek elektronikus használati útmutatóit (eIFU).',
  'Checking the latest documents.': 'A legfrissebb dokumentumok ellenőrzése.',
  'There are no manuals to display.': 'Nincs megjeleníthető kézikönyv.',
  Manuals: 'Kézikönyvek',
  'Product Name': 'Terméknév',
  Language: 'Nyelv',
  'Document Name': 'Dokumentum neve',
  Product: 'Termék',
  Revision: 'Változat',
  Document: 'Dokumentum',
  Published: 'Közzétéve',
  Country: 'Ország',
  'All countries': 'Összes ország',
  Search: 'Keresés',
  'No results': 'Nincs találat',
  'appManuals.downloadHelpText':
    'A letöltött fájlok internetböngészőben vagy PDF-olvasó szoftverrel tekinthetők meg.',
  'appManuals.systemRequirements':
    'Rendszerkövetelmények: Intel® Core™ i3 vagy újabb processzor, legalább 4 GB memória, legalább 100 MB szabad tárhely a PDF mentéséhez.',
  'criticalNotice.badge': 'Fontos közlemény',
  'criticalNotice.close': 'Bezárás',
};

export default hu;
